var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fraction"},[_vm._t("top",function(){return [_vm._v(" "+_vm._s(_vm.top)+" ")]}),_c('div',{staticClass:"fraction-bottom"},[_vm._t("bottom",function(){return [_vm._v(" "+_vm._s(_vm.bottom)+" ")]})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }